import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Play } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { initiales, formatEuros } from "@/lib/format";
import { Bulle, Info, Profil } from "./Wa";
import { Accueil3Colonnes } from "./AccueilWa";

const rendu = (x) => (
  <>
    <Bulle choisie testId="wa-item-bubble"><p className="font-semibold">{x.titre}</p>{x.texte && <p className="text-[13px] at-muted mt-0.5">{x.texte}</p>}</Bulle>
    {x.lien && <div className="ml-2"><Link to={x.lien} className="wa-avancer" data-testid="wa-item-open"><Play size={13} />Ouvrir</Link></div>}
  </>
);

export const AccueilDirigeantWa = () => {
  const { user } = useAuth();
  const [t, setT] = useState(null);
  const [a, setA] = useState(null);
  const [b, setB] = useState(null);
  useEffect(() => {
    api.get("/tableaux/dirigeant").then((r) => setT(r.data)).catch(() => setT({ alertes: [], recommandations: [] }));
    api.get("/accueil").then((r) => setA(r.data)).catch(() => {});
    api.get("/assistant").then((r) => setB(r.data.briefing)).catch(() => {});
  }, []);
  if (!t) return <p className="at-muted p-6">Chargement…</p>;
  const items = [
    ...t.alertes.map((x, i) => ({ id: `al-${i}`, type: "alertes", titre: x.titre, sous: x.detail, texte: x.detail, lien: x.lien, badge: "!", couleur: "var(--danger)", rond: "⚠️" })),
    ...t.recommandations.map((x, i) => ({ id: `re-${i}`, type: "conseils", titre: x.titre, sous: x.detail, texte: x.detail, lien: x.lien, couleur: "var(--accent-ia, var(--accent))", rond: "💡" })),
    ...(b?.priorites || []).map((x, i) => ({ id: `pr-${i}`, type: "priorites", titre: x.texte, sous: "Priorité du jour", lien: x.lien, rond: `${i + 1}` })),
  ];
  const detail = (
    <Profil initiales={initiales(user)} nom={`${user.prenom} ${user.nom}`} sous={user.role_label} testId="wa-profile">
      <p className="at-label mb-1">En ce moment</p>
      {a && <Info label="Fiches en cours" valeur={a.nb_fiches} testId="stat-nb-fiches" />}
      {a && <Info label="Montant estimé" valeur={formatEuros(a.montant_total)} testId="stat-montant-total" />}
      {a && <Info label="Sans action" valeur={a.sans_action} testId="stat-sans-action" />}
      {a && <Info label="Délai dépassé" valeur={a.en_retard} testId="stat-en-retard" />}
      {t.prevision && <Info label="Signés ce mois" valeur={formatEuros(t.prevision.montant_signe ?? 0)} />}
      <Link to="/?vue=tableau" className="at-btn at-btn-ghost w-full mt-5" data-testid="wa-full-dashboard">Tableau de bord complet</Link>
    </Profil>
  );
  return (
    <div className="contents" data-testid="page-accueil">
      <Accueil3Colonnes testId="wa-home" items={items} briefing={b} detail={detail}
        filtres={[["tout", "Tout"], ["alertes", "Alertes"], ["conseils", "Conseils"], ["priorites", "Priorités"]]} rendu={rendu} />
    </div>
  );
};
